import Api from "../../../util/Api";

export default function getInitState() {
    return {
        logOpen: true,
        certOpen: false,

        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        viewActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-file-signature"></i> Tanúsítványok',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'showCertifications'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-share"></i>',
                title: 'Kimenő üzenet',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'showOutMessage'
            },
            {
                btn_text: '<i class="fas fa-reply"></i>',
                title: 'Bejövő üzenet',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'showInMessage'
            },
        ],
        searchFields: [
            {
                name: "medUsername",
                label: "Medici felhasználónév",
                sort: true,
                visibility: true,
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getUserWithEesztUser,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'medUsername',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "applicationFunctionId",
                label: "EESZT funkció",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getEesztFunctionTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "result",
                label: "Lefutás",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {
                            id: "1",
                            text: 'Sikeres'
                        },
                        {
                            id: "2",
                            text: 'Sikertelen'
                        }
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "organizationId",
                label: "Intézet azonosító",
                formSize: 4,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompaniesWithEesztData,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'nyilvantartasiSzam',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "organizationUnitId",
                label: "Szervezet azonosító",
                formVisible: true,
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllOrganizationUnitsForSelect,
                    formatText: function (val) {
                        return val.organizationUnitName;
                    },
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "integrationId",
                label: "Integration ID",
                formSize: 4,
                formVisible: true,
                formType: "text"
            },
            {
                name: "startTimeFrom",
                label: "Időponttól",
                formSize: 4,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "startTimeTo",
                label: "Időpontig",
                formSize: 4,
                formVisible: true,
                formType: 'date'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
            },
            {
                name: "medUsername",
                label: "Medici felhasználónév",
                sort: true,
                visibility: true,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getUserWithEesztUser,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'medUsername',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "eesztUsername",
                label: "EESZT felhasználónév",
                sort: true,
                visibility: true,
            },
            {
                name: "applicationFunction.text",
                label: "EESZT funkció",
                sort: false,
                visibility: true,
            },
            {
                name: "organizationId",
                label: "Intézet azonosító",
                sort: true,
                visibility: true,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompaniesWithEesztData,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'nyilvantartasiSzam',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "organizationName",
                label: "Intézet neve",
                sort: true,
                visibility: true
            },
            {
                name: "organizationUnitId",
                label: "Szervezet azonosító",
                sort: true,
                visibility: true,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllOrganizationUnitsForSelect,
                    formatText: function (val) {
                        return val.organizationUnitName;
                    },
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "organizationUnitName",
                label: "Szervezet",
                sort: true,
                visibility: true
            },
            {
                name: "startTime",
                label: "Időpont",
                sort: true,
                visibility: true,
                slot_name: "datetime_format"
            },
            {
                name: "result",
                label: "Lefutás",
                sort: true,
                visibility: true
            },
            {
                name: "errorCode",
                label: "Hibakód",
                sort: true,
                visibility: true
            },
            {
                name: "errorMessage",
                label: "Hiba",
                sort: true,
                visibility: true
            },
            {
                name: "integrationId",
                label: "Integration ID",
                sort: true,
                visibility: true
            },
            {
                name: "outMessageXml",
                label: "Kimenő üzenet",
                visibility: false
            },
            {
                name: "inMessageXml",
                label: "Bejövő üzenet",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        viewHeaderFields: [
            {
                name: "applicationFunction.text",
                label: "EESZT funkció",
                sort: false,
                visibility: true,
            },
            {
                name: "organizationId",
                label: "Intézet azonosító",
                sort: true,
                visibility: true,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompaniesWithEesztData,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'nyilvantartasiSzam',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "organizationName",
                label: "Intézet neve",
                sort: true,
                visibility: true
            },
            {
                name: "organizationUnitId",
                label: "Szervezet azonosító",
                sort: true,
                visibility: true,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllOrganizationUnitsForSelect,
                    formatText: function (val) {
                        return val.organizationUnitName;
                    },
                    formatOption: function (val) {
                        return val.organizationUnitName + " (" + val.organizationUnitId + ")";
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'organizationUnitName',
                    returnValue: 'organizationUnitId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "organizationUnitName",
                label: "Szervezet",
                sort: true,
                visibility: true
            },
            {
                name: "startTime",
                label: "Időpont",
                sort: true,
                visibility: true,
                slot_name: "datetime_format"
            },
            {
                name: "result",
                label: "Lefutás",
                sort: true,
                visibility: true
            },
            {
                name: "errorCode",
                label: "Hibakód",
                sort: true,
                visibility: true
            },
            {
                name: "errorMessage",
                label: "Hiba",
                sort: true,
                visibility: true
            }
        ],

        eesztCertActions: [
            {
                btn_text: '<i class="fas fa-arrow-left"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'showLogs'
            }
        ],
        eesztCertHeaderFields: [
            {
                name: "alias",
                label: "Tanúsítvány",
                visibility: true,
                sort: false
            },
            {
                name: "version",
                label: "Verzió",
                visibility: false
            },
            {
                name: "serialNumber",
                label: "Sorozatszám",
                visibility: false
            },
            {
                name: "subject",
                label: "Tulajdonos adatai",
                visibility: true,
                sort: false
            },
            {
                name: "issuer",
                label: "Kibocsátó adata",
                visibility: true,
                sort: false
            },
            {
                name: "expireDate",
                label: "Lejárat dátuma",
                visibility: true,
                sort: false,
                slot_name: "date_format"
            },
            {
                name: "valid",
                label: "Érvényes",
                visibility: true,
                sort: false,
                slot_name: "format_eeszt_cert"
            },
            {
                name: "filePath",
                label: "Fájl",
                visibility: true,
                sort: false
            },
        ]
    }
}

